import { ResolveFn } from '@angular/router';
import {inject} from '@angular/core';
import {CommunityService} from '../../../services/community.service';
import {Community} from '../classes/community';

export const communityResolver: ResolveFn<Community> = (route) => {
  return inject(CommunityService)
    .getCommunityById(parseInt(route.paramMap.get('id')!));

};
